import { render } from "./createApplication.vue?vue&type=template&id=6b36ed57"
import script from "./createApplication.vue?vue&type=script&lang=js"
export * from "./createApplication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__